import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BlockUIModule } from 'ng-block-ui';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ajaxCall } from './core/services/ajax-call.service';
import { HttpClientModule } from '@angular/common/http';
import { LoginRootComponent } from './login-root/login-root.component';
import { AdminRootComponent } from './admin-root/admin-root.component';
import { FormsModule } from '@angular/forms';
import { UsersModule } from './users/users.module';
import { NotifierModule } from 'angular-notifier';
import { SetPasswordComponent } from './login-root/set-password.component';
import { PasswordStrengthMeterComponent, PasswordStrengthMeterModule } from 'angular-password-strength-meter';
import { MustMatchDirective, MustEqualDirective } from './core/validators.model';
import { ConfirmComponent } from './core/confirm/confirm.component';
import { AdminDashboardModule } from './admin-dashboard/admin-dashboard.module';
import { LandingRootComponent } from './landing-root/landing-root.component';
import { MyProfileComponent } from './core/my-profile/my-profile.component';
import { FileUploadModule } from 'ng2-file-upload';
import { SettingsComponent } from './admin-root/settings/settings.component';
import { NgbDropdownModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { SettingsPropertiesComponent } from './admin-root/settings-properties/settings-properties.component';
import { DirtyTrackingDirective } from './core/dirty-tracking/dirty-tracking.directive';
import { DirtyTrackingService } from './core/dirty-tracking/dirty-tracking.service';
import { CanDeactivateGuard } from './core/dirty-tracking/dirty-tracking.guard';
import { CoreModule } from './core/core.module';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { EntitiesModule } from './entities/entities.module';
import { VendorsModule } from './vendors/vendors.module';
import { OrdersModule } from './orders/orders.module';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

@NgModule({
  declarations: [
    AppComponent,
    LoginRootComponent,
    AdminRootComponent,
    SetPasswordComponent,
    LandingRootComponent,
    SettingsComponent,
    SettingsPropertiesComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    BlockUIModule.forRoot(),
    HttpClientModule,
    UsersModule,
    CoreModule,
    EntitiesModule,
    VendorsModule,
    OrdersModule,
    AdminDashboardModule,
    PasswordStrengthMeterModule,
    NotifierModule.withConfig({
      position: {
        horizontal: {
          position: 'middle'
        },
        vertical: {
          position: 'top'
        }
      }
    }),
    MalihuScrollbarModule.forRoot(),
    FileUploadModule,
    NgbDropdownModule,
    NgbModalModule,
    CKEditorModule,
  ],
  providers: [
    ajaxCall,
    DirtyTrackingService,
    CanDeactivateGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
